import React, { ReactNode } from "react";

import { Layout } from "antd";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import styled from "styled-components";

import NavigationHeader from "components/navigations/header";
import PageLoading from "components/page-loding";

import useSetPageTitle from "hooks/set-page-title";

const Container = styled.div<{ background: string | undefined }>`
  background: ${(props) => props?.background || props.theme.colorBgContainer};
  padding: ${(props) => props.theme.paddingMD}px;
  height: 99%;
  width: 100%;
  overflow: auto;
`;

const Content = styled(Layout.Content)<{ fullscreen: string }>`
  height: 97%;
  margin: ${(props) => (props.fullscreen === "true" ? "8px 0" : "24px 24px 0 24px")};
`;

const AutoScrollContainer = styled(OverlayScrollbarsComponent)`
  height: calc(100vh - 52px);
`;

export const AppLayoutContent = ({ children, background }: { children: ReactNode; background?: string }) => {
  return <Container background={background}>{children}</Container>;
};

interface AppLayoutProps {
  children: ReactNode;
  fullscreen?: boolean;
  pageTitle: string;
  label?: ReactNode;
  loading?: boolean;
  autoScroll?: boolean;
}

const AppLayout = ({
  children,
  label,
  pageTitle,
  fullscreen = false,
  loading = false,
  autoScroll = false,
}: AppLayoutProps) => {
  useSetPageTitle(pageTitle);

  return (
    <>
      <PageLoading pageLoading={loading}>
        <NavigationHeader label={label} />
        <AutoScrollContainer
          defer
          // @ts-ignore
          options={{ scrollbars: { autoHide: "scroll", visibility: autoScroll ? "auto" : "hidden" } }}
          element="div"
        >
          <Content fullscreen={`${fullscreen}`}>{children}</Content>
        </AutoScrollContainer>
      </PageLoading>
    </>
  );
};

export default AppLayout;
